// extracted by mini-css-extract-plugin
module.exports = {"bg":"App_bg__1wpxE","body":"App_body__2NF7o"};